import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

export default function CtaBand() {
  return (
    <section className="bg-primary-950 py-12 md:py-16">
      <div className="mx-auto max-w-[1360px] px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-center">
          <div className="max-w-2xl">
            <p className="mb-2 flex items-center gap-2 font-label text-xs font-medium uppercase tracking-[0.2em] text-accent-400">
              <span className="block h-px w-6 bg-accent-400" aria-hidden="true" />
              线索投递
            </p>
            <h2 className="mb-3 font-heading text-xl font-bold text-background-50 md:text-3xl">
              手上有还没被讲清楚的线索？
            </h2>
            <p className="text-sm leading-relaxed text-background-300 md:text-base">
              把原始出处、时间点和你能确认的细节发给我们。我们会在核对后决定是否建档追踪，并在时间线里如实标注信源状态。
            </p>
          </div>
          <div className="flex w-full shrink-0 flex-col gap-3 sm:flex-row lg:w-auto">
            <Link
              to="/about#contact"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-send-plane-line" />
              前往投递入口
            </Link>
            <a
              href={`mailto:${siteInfo.cooperation}`}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/25 px-6 py-3 font-label text-sm text-background-100 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-mail-line" />
              邮件联系编辑部
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}